<template>
	<div class="criteria">
		<div
			class="criteria__oval"
			:class="{'criteria__oval--success': success}"
		/>
		<div class="criteria__text">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'Criteria',
	props: {
		success: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
};
</script>

<style scoped lang="scss" src="./criteria.scss" />
